
/**
 * Bind params to a given url
 * @param to
 * @param params
 */
export const joinUrlWithParams = (to: string, params: Array<{ param: string; value: any }>) => {
	let url = to;
	params.forEach(param => {
		url = url.replace(`:${param.param}`, `${encodeURIComponent(param.value)}`);
	});

	return url;
};

/**
 * Shortcut of joinUrlWithParams for Id
 * @param to
 * @param id
 */
export const joinUrlWithParamsId = (to: string, id: string | number) => joinUrlWithParams(to, [{ param: 'id', value: id }]);
